import { useQuery } from '@tanstack/react-query';
import { axiosRequest } from '@lib/axios';

/**
 * React Query wrapper for the Pears query.
 */
const usePearsQuery = () => {
  return useQuery({
    queryKey: ['pears'],
    queryFn: async () => axiosRequest({ method: 'GET', url: '/data/pears' }),
    structuralSharing: false,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default usePearsQuery;
